import { render, staticRenderFns } from "./PartnerFooter.vue?vue&type=template&id=c7871e1c&scoped=true&"
import script from "./PartnerFooter.vue?vue&type=script&lang=js&"
export * from "./PartnerFooter.vue?vue&type=script&lang=js&"
import style0 from "./PartnerFooter.vue?vue&type=style&index=0&id=c7871e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7871e1c",
  null
  
)

export default component.exports